import extend from 'extend';

import login from './components/login';
import errorMessages from './components/errorMessages';

const components = [];
const target = {};

components.push(login);
components.push(errorMessages);

extend(true, target, ...components);

export default target;
